import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { Loader } from 'semantic-ui-react';
import CloseIcon from '../../Icons/Close';
import './PdfViewModal.scss';

const MODAL_STYLE = {
  content: {
    margin: '0 auto',
    maxWidth: '70%',
    position: 'relative',
    height: '90%',
    padding: 0,
  },
};

const PdfView = ({ url, onClose, ...props }) => (
  <Modal isOpen={!!url} style={MODAL_STYLE} {...props}>
    <CloseIcon onClick={onClose} />
    <div className="pdf-container">
      {/* Loader is covered when iframe content loads */}
      <Loader content="loading" active />
      <iframe
        src={url}
        width={'100%'}
        height={'100%'}
        border={0}
        title={'PDF form'}
        className="pdf-iframe"
      />
    </div>
  </Modal>
);

PdfView.propTypes = {
  url: PropTypes.string,
  onClose: PropTypes.func,
};

export default PdfView;
